// extracted by mini-css-extract-plugin
export var formContainer = "_lk-0";
export var message = "_lk-1";